// Environment Configuration
export const ENV_CONFIG = {
  // API Configuration
  // API_URL: process.env.REACT_APP_API_URL || 'http://localhost:3001',
  API_URL: process.env.REACT_APP_API_URL || 'https://app.panchkaram.com',
  
  // App Configuration
  APP_NAME: process.env.REACT_APP_APP_NAME || 'Panchakarma Admin',
  APP_VERSION: process.env.REACT_APP_VERSION || '1.0.0',
  
  // Development Configuration
  IS_DEVELOPMENT: process.env.NODE_ENV === 'development',
  IS_PRODUCTION: process.env.NODE_ENV === 'production',
  
  // Feature Flags
  ENABLE_LOGGING: process.env.REACT_APP_ENABLE_LOGGING === 'true',
  ENABLE_ANALYTICS: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
};

// Helper function to get environment variable with fallback
export const getEnvVar = (key: string, fallback: string = ''): string => {
  return process.env[key] || fallback;
};

// Helper function to check if we're in development mode
export const isDevelopment = (): boolean => {
  return ENV_CONFIG.IS_DEVELOPMENT;
};

// Helper function to check if we're in production mode
export const isProduction = (): boolean => {
  return ENV_CONFIG.IS_PRODUCTION;
};
